import SaerchIcon from './SearchIcon';

export default SaerchIcon;
